function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEasyDetectMobileNav({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M16.5 8.9175V9.585C16.5 12.255 15.8325 12.915 13.17 12.915H4.83C2.1675 12.915 1.5 12.2475 1.5 9.585V4.83C1.5 2.1675 2.1675 1.5 4.83 1.5H6",
    stroke: "#080917",
    style: {
      stroke: "#080917",
      strokeOpacity: 1
    },
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9 12.915V16.5",
    stroke: "#080917",
    style: {
      stroke: "#080917",
      strokeOpacity: 1
    },
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.5 9.75H16.5",
    stroke: "#080917",
    style: {
      stroke: "#080917",
      strokeOpacity: 1
    },
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.625 16.5H12.375",
    stroke: "#080917",
    style: {
      stroke: "#080917",
      strokeOpacity: 1
    },
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.3951 7.02751H9.82507C8.79007 7.02751 8.44507 6.33751 8.44507 5.64751V3.00751C8.44507 2.18251 9.12007 1.50751 9.94507 1.50751H13.3951C14.1601 1.50751 14.7751 2.12251 14.7751 2.88751V5.64751C14.7751 6.41251 14.1601 7.02751 13.3951 7.02751Z",
    stroke: "#080917",
    style: {
      stroke: "#080917",
      strokeOpacity: 1
    },
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.6824 5.93998L14.7749 5.30248V3.23248L15.6824 2.59498C16.1324 2.28748 16.4999 2.47498 16.4999 3.02248V5.51998C16.4999 6.06748 16.1324 6.25498 15.6824 5.93998Z",
    stroke: "#080917",
    style: {
      stroke: "#080917",
      strokeOpacity: 1
    },
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEasyDetectMobileNav);
export default __webpack_public_path__ + "static/media/easy-detect-mobile-nav.64c341236fc7848fdfc182d613208210.svg";
export { ForwardRef as ReactComponent };